import { render, staticRenderFns } from "./section-collect-card.vue?vue&type=template&id=a4ecdcac"
import script from "./section-collect-card.vue?vue&type=script&lang=js"
export * from "./section-collect-card.vue?vue&type=script&lang=js"
import style0 from "./section-collect-card.vue?vue&type=style&index=0&id=a4ecdcac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.11_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0_gf3z3nxy4xzyghx7z43uzvzowq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports